<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="salesOrderChanges"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select
                  v-model="filter.salesOrderCategory"
                  clearable
                  placeholder="请选择订单类型">
                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="变更类型">
              <el-select v-model="filter.changeType" clearable placeholder="请选择">
                <el-option label="价格变更" value="0"/>
                <el-option label="订单取消" value="1"/>
                <el-option label="物料变更-型号不变,物料替代" value="2"/>
                <el-option label="物料变更-型号变化" value="3"/>
                <el-option label="数量减少" value="4"/>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" clearable placeholder="请选择">
                <el-option label="全部" value=""/>
                <el-option label="待确认" value="0"/>
                <el-option label="计划已确认" value="1"/>
              </el-select>
            </el-form-item>
            <el-form-item label="变更单号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入变更单号" clearable/>
            </el-form-item>
            <el-form-item label="创建人">
              <el-input v-model.trim="filter.createrBy" placeholder="请输入创建人" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.changeAuth"
            type="primary"
            @click="goToHistoryPage(scope.row)">
          变更记录
        </el-button>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
    <sap-delivery-edit ref="sapDeliveryEdt"/>
  </div>
</template>

<script>
  import SalesOrderEdit from "@/views/SalesManage/SalesOrder/SalesOrderEdit";
  import ViewTable from "@/components/ViewTable";
  import SapDeliveryEdit from "@/views/SalesManage/DeliveryBll/SapDeliveryEdit";

  export default {
    name: "SalesOrderChangeList",
    components: {SapDeliveryEdit, SalesOrderEdit,ViewTable},
    data() {
      return {
        limits: {
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(135),
          changeAuth: this.$auth(353),
        },
        options: [],
        property: [],
        createTimeRange: [],
        filter: {
          salesOrderCategory: "",
          salesOrderNo: "",
          customerName: "",
          status: "",
          changeType: "",
          billNo: "",
          createrBy: "",
          createTimeBegin: "",
          createTimeEnd: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "salesOrderNO",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.salesOrderNO,
              );
            },
          },
          {
            key: "action",
            width: 110,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },
    mounted() {
      this.getSalesOrderCategory();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      getSalesOrderCategory() {
        this.$http.get("basic", "sapSalesOrders/getSalesOrderCategory").then((res) => {
          if (res.success) {
            this.property = res.data;
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      goToHistoryPage(row) {
        this.$router.push({
          path:"/SalesOrderChangeHistory",
          query:{
            pkId:row.pkId,
            billNo:row.billNo,
          },
        });
      },
    },
  };
</script>
